import { render, staticRenderFns } from "./ConfirmationSave.vue?vue&type=template&id=12287fd9&"
import script from "./ConfirmationSave.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports